import Config from "@app/constants/Config";
import localforage from "localforage";
import { getSetting } from "@app/models/settings";
import { authMiddleware } from "@app/utils/helper";
import { OutdatedError } from "@app/lib/errors/OutdatedError";

const store = localforage.createInstance({
	name: "jobs",
});

async function loadJobs() {
	const response = await fetch(Config.API.JOBS.LOAD, {
		credentials: "include",
	});
	await authMiddleware(response);
	return response.json();
}

export async function getJobs() {
	let jobs = await store.getItem("jobs");
	let measuresCatalogue = await store.getItem("measuresCatalogue");
	let measuresByInfluence = await store.getItem("measuresByInfluence");
	let cacheTime = await store.getItem("cacheTime");

	const valid =
		!!jobs &&
		!!measuresCatalogue &&
		!!measuresByInfluence &&
		cacheTime &&
		cacheTime + Config.API.JOBS.CACHE > Date.now();
	if (!valid && navigator.onLine) {
		const loadedData = await loadJobs();
		jobs = loadedData.QAMatrix;
		measuresCatalogue = loadedData.Katalog;
		measuresByInfluence = loadedData.Gefaehrdung;
		jobs = jobs.map((job) => ({
			PSA: {},
			Typische_Gefaehrdung: "",
			Unterweisung: {},
			Vorsorgeuntersuchung: {},
			Score: 999999,
			...job,
		}));
		jobs = jobs.sort((a, b) => b.Score - a.Score);
		await store.setItem("jobs", jobs);
		await store.setItem("measuresCatalogue", measuresCatalogue);
		await store.setItem("measuresByInfluence", measuresByInfluence);
		await store.setItem("cacheTime", Date.now());
	}
	if (!valid && !navigator.onLine) {
		throw new OutdatedError("job");
	}
	if (!jobs) {
		throw new Response("", {
			status: 500,
			statusText: "Jobs data is not available",
		});
	}
	return {
		jobs,
		measuresByInfluence,
		measuresCatalogue,
	};
}

export async function clearJobs() {
	return store.clear();
}
